<div class="form-inner">
  <ng-template #customItemTemplate let-model="item">
    <div class="search-dropdown-inner">
      <ul
        [ngClass]="{
          searchhastagList: model.dataType === 'hashtag' || model.is_taxonomy
        }"
        class="search-dropdownList"
      >
        <li>
          <div *ngIf="model.is_taxonomy" class="search-user-pic">
            <app-tick-icon
              [creatorData]="{is_creator: true}"
            ></app-tick-icon>
          </div>
          <div *ngIf="model.dataType === 'creators'" class="search-user-pic">
            <img
              *ngIf="model.profile_image_url"
              appDisableRightClick
              appMobileOptimization
              [originalUrl]="model.profile_image_url"
              [src]="model.profile_image_url"
              [format]="'webp'"
              alt="search profile"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div
            *ngIf="model.dataType === 'hashtag' && model.type === 'data'"
            class="search-user-pic"
          >
            #
          </div>
          <div
            [ngClass]="{ 'search-see-results': model.type === 'button' }"
            class="search-user-title"
          >
            <span class="search-title">{{ model.fullName }}</span>
            <span
              *ngIf="
                model.dataType === 'creators' &&
                model.category &&
                model.category.length
              "
              class="search-subtitle"
            >
              {{ model.category[0].category_name }}
            </span>
          </div>
        </li>
      </ul>
    </div>
  </ng-template>
  <input
    #search
    [(ngModel)]="searchObj.text"
    [typeahead]="suggestions$"
    [typeaheadAsync]="true"
    [typeaheadItemTemplate]="customItemTemplate"
    [isAnimated]="true"
    [typeaheadScrollable]="true"
    [typeaheadAsync]="true"
    (typeaheadOnSelect)="selectOption($event)"
    type="text"
    id="search"
    name="search"
    role="combobox"
    typeaheadOptionField="fullName"
    typeaheadGroupField="label"
    placeholder="Search Creators or Interests"
    autocomplete="off"
  />
  <a *ngIf="searchObj.text" (click)="clearSearch()" class="icon-close">
    <em>&#x2715;</em>
  </a>
</div>
